import { RedoNotification } from "@redotech/redo-web/arbiter-components/notification/redo-notification";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OnboardingProps } from "../common";
import * as styles from "./supplies-free-labels-announcement-modal.module.css";
import freeLabelsHeroUrl from "./supplies-free-labels-white-oak.png?url";
import { useStartSuppliesShopping } from "./use-start-supplies-shopping";

export const SuppliesFreeLabelsAnnouncementModal = memo(
  function SuppliesFreeLabelsAnnouncementModal({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const [shoppingState, startShopping] =
      useStartSuppliesShopping(handleComplete);

    return (
      <div className={styles.notificationHost}>
        <RedoNotification
          breakpoint="mobile"
          buttonAlignment="right"
          darkMode
          dataTestId="supplies-free-labels-announcement"
          dismiss={handleDismiss}
          dismissButton={{ text: "Dismiss" }}
          fullModalImage={freeLabelsHeroUrl}
          hideCloseX
          primaryButton={{
            onClick: () => startShopping(),
            pending: shoppingState.pending,
            text: "Start shopping",
            theme: "action",
          }}
        >
          {() => (
            <Flex dir="column" gap="xs">
              <Text fontSize="sm" fontWeight="semibold" textColor="primary">
                LAST CHANCE!
              </Text>
              <Text fontSize="sm" fontWeight="regular" textColor="secondary">
                Get over $100 of labels when you spend over $200 on any Redo
                supplies.
                <br />
                <br />
                Offer ends July 31st at midnight.
              </Text>
            </Flex>
          )}
        </RedoNotification>
      </div>
    );
  },
);
